import { getResponsiveProp, responsive } from '../helpers';
export function flexItemStyle(_ref) {
  var flex = _ref.flex,
      theme = _ref.theme;
  return responsive(theme.sanity.media, getResponsiveProp(flex).map(function (val) {
    return {
      flex: val
    };
  }));
}